export default {
  riskAssessmentDriver: [
    {
      id: "Driving Company Vehicles",
      title: "Driving Company Vehicles"
    },
    {
      id: "Refuelling Operations",
      title: "Refuelling Operations"
    },
    {
      id: "Tipping of Vehicles",
      title: "Tipping of Vehicles"
    },
    {
      id: "Violence at Work",
      title: "Violence at Work"
    },
    {
      id: "Sun Exposure",
      title: "Sun Exposure"
    },
    {
      id: "Lone Working",
      title: "Lone Working"
    },
    {
      id: "General Manual Handling Activities",
      title: "General Manual Handling Activities"
    },
    {
      id: "Environmental Spillage",
      title: "Environmental Spillage"
    },
    {
      id: "Collection of Blue Boxes & Red Bags",
      title: "Collection of Blue Boxes & Red Bags"
    },
    {
      id: "Collection & Disposal of Seagull Proof Bags & Black Sacks",
      title: "Collection & Disposal of Seagull Proof Bags & Black Sacks"
    },
    {
      id: "Collection & Disposal of Green Waste",
      title: "Collection & Disposal of Green Waste"
    },
    {
      id: "Blood Borne Viruses",
      title: "Blood Borne Viruses"
    }
  ].sort((a, b) => a.title.localeCompare(b.title)),
  riskAssessmentNonDriver: [
    {
      id: "Violence at Work",
      title: "Violence at Work"
    },
    {
      id: "Sun Exposure",
      title: "Sun Exposure"
    },
    {
      id: "Lone Working",
      title: "Lone Working"
    },
    {
      id: "General Manual Handling Activities",
      title: "General Manual Handling Activities"
    },
    {
      id: "Environmental Spillage",
      title: "Environmental Spillage"
    },
    {
      id: "Collection of Blue Boxes & Red Bags",
      title: "Collection of Blue Boxes & Red Bags"
    },
    {
      id: "Collection & Disposal of Seagull Proof Bags & Black Sacks",
      title: "Collection & Disposal of Seagull Proof Bags & Black Sacks"
    },
    {
      id: "Collection & Disposal of Green Waste",
      title: "Collection & Disposal of Green Waste"
    },
    {
      id: "Blood Borne Viruses",
      title: "Blood Borne Viruses"
    }
  ].sort((a, b) => a.title.localeCompare(b.title))
};
